import { Post } from '@/types/post';
import axios, { AxiosError } from 'axios';
import { TableStore } from '@/pages/Admin/Stores';
import { TableVouchers } from '@/pages/Admin/Vouchers';
import apiClient from './_axios';

const API_URL = import.meta.env.VITE_API_URL; // or from '@/constants'

interface VoucherResponse {
   vouchers: TableVouchers[];
   msg?: string;
   totalProcessed?: number;
   totalInserted?: number;
   totalDuplicates?: number;
   errors?: Array<{
      code?: string;
      error?: string;
      chunk?: number;
   }>;
}

interface RateLimitError {
   status: number;
   message: string;
   retryAfter: number;
   currentCount: number;
   attemptedCount: number;
}

// const token =
//    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2N2Q5M2RkMmJiYzQ4Yjk1Nzg3ZTZjYzAiLCJpYXQiOjE3NDIyOTM5MzB9.PYeL53rBVU6O8ev1__HyO4Es8sdvD_58Rn38xZ8DRnY';

// export async function fetchVoucherss(): Promise<VoucherResponse> {
//    // Access token from Zustand store
//    const token = useAuthStore.getState().token;
//    if (!token) {
//       throw new Error('No authentication token available');
//    }

//    const response = await axios.get<VoucherResponse>(`${API_URL}/voucher`, {
//       headers: {
//          'Content-Type': 'application/json',
//          Authorization: `Bearer ${token}`,
//       },
//    });
//    return response.data;
// }

export async function fetchVoucherss(): Promise<VoucherResponse> {
   const response = await apiClient.get<VoucherResponse>('/voucher?limit=10000');

   return response.data;
}

export async function createVoucher(
   voucher: TableVouchers
): Promise<VoucherResponse> {
   try {
      const response = await apiClient.post<VoucherResponse>(
         '/voucher/create',
         voucher
      );

      // console.log(response);
      return response.data;
   } catch (err) {
      if (err instanceof AxiosError && err.response?.status === 429) {
         throw {
            status: 429,
            message: err.response.data.message || 'Rate limit exceeded',
            retryAfter: err.response.data.retryAfter,
            currentCount: err.response.data.currentCount,
            attemptedCount: err.response.data.attemptedCount,
         } as RateLimitError;
      }

      // Handle other errors
      throw err;
   }
}

// export async function createVoucher(voucher: TableVouchers) {
//    const token = localStorage.getItem('x-token');
//    try {
//       const response = await axios.post(`${API_URL}/voucher/create`, voucher, {
//          headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//          },
//       });
//       return response.data;
//    } catch (err) {
//       if (axios.isAxiosError(err) && err.response?.status === 429) {
//          throw {
//             status: 429,
//             message: err.response.data.message || 'Rate limit exceeded',
//             retryAfter: err.response.data.retryAfter,
//             currentCount: err.response.data.currentCount,
//             attemptedCount: err.response.data.attemptedCount,
//          };
//       }

//       // Handle other errors
//       throw err;
//    }
// }

export const updateVoucher = async (
   voucherId: string,
   data: { code: string; title: string; description: string; duration: string; price: number; store: string }
) => {
   const response = await apiClient.put(`/voucher/update/${voucherId}`, data);
   return response.data;
};

export const deleteVoucher = async (voucherId: string) => {
   const response = await apiClient.delete(`/voucher/${voucherId}`);
   return response.data;
};

export const bulkDeleteVouchers = async (ids: string[]) => {
   const response = await apiClient.post('/voucher/bulk-delete', { ids });
   return response.data;
};

export const importVoucherCSV = async (file: File, storeId: string) => {
   const formData = new FormData();
   formData.append('file', file);
   formData.append('store', storeId);

   try {
      const response = await apiClient.post('/voucher/import-csv', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      return response.data;
   } catch (err: unknown) {
      // Handle rate limit exceeded error (429)
      if (axios.isAxiosError(err) && err.response?.status === 429) {
         throw {
            status: 429,
            message: err.response.data.message || 'Rate limit exceeded',
            retryAfter: err.response.data.retryAfter,
            currentCount: err.response.data.currentCount,
            attemptedCount: err.response.data.attemptedCount,
         };
      }

      // Handle other errors
      throw err;
   }
};

export const getAvailableVouchers = async () => {
   const response = await apiClient.get('/voucher/available');
   return response.data;
};

export const getSoldVouchers = async () => {
   const response = await apiClient.get('/voucher/sold');
   return response.data;
};
